export default {
  menu: 'Sale suggest',
  title: 'Sale suggest',

  table: {
    header: {
      row: 'Row',
      image: 'Image',
      barcode: 'Barcode',
      code: 'Code',
      category: 'Category',
      name: 'Title',
      variant: 'Variant',
      score: 'Point',
      totalSold: 'Total sold',
      saleInventory: 'Sale inventory'
    }
  }
}
